export const iconFontAwesomeWritingPenClip = (
	<i className="fa-solid fa-pen-clip"></i>
);
